import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { FaRocket, FaClock, FaFire } from 'react-icons/fa';
import './PresaleHero.css';

const PresaleHero = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const presaleEndDate = new Date('2025-11-30T23:59:59');

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const difference = presaleEndDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const scrollToParticipate = () => {
    const element = document.getElementById('participate');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="presale-hero">
      <Container>
        <Row className="align-items-center">
          <Col lg={12}>
            <div className="presale-hero-content text-center">
              <div className="presale-badge mb-3" data-aos="fade-up">
                <FaRocket className="me-2" />
                <span>MCGP Token Presale</span>
              </div>

              <h1
                className="presale-title"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                The Future of the Tokenized Economy{' '}
                <span className="gradient-text">Begins Now</span>
              </h1>

              <p
                className="presale-subtitle"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                Join the MCGP Revolution — Secure your MCGP holdings at the
                exclusive presale rate
              </p>

              <div
                className="presale-price-box"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <div className="presale-price">
                  <span className="price-label">Presale Price</span>
                  <span className="price-value">1 MCGP = $0.01</span>
                </div>
              </div>

              <div
                className="countdown-wrapper"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <div className="countdown-header">
                  <FaClock className="me-2" />
                  <span>Presale Ends In</span>
                </div>
                <div className="countdown-timer">
                  <div className="countdown-item">
                    <span className="countdown-value">{timeLeft.days}</span>
                    <span className="countdown-label">Days</span>
                  </div>
                  <div className="countdown-separator">:</div>
                  <div className="countdown-item">
                    <span className="countdown-value">{timeLeft.hours}</span>
                    <span className="countdown-label">Hours</span>
                  </div>
                  <div className="countdown-separator">:</div>
                  <div className="countdown-item">
                    <span className="countdown-value">{timeLeft.minutes}</span>
                    <span className="countdown-label">Minutes</span>
                  </div>
                  <div className="countdown-separator">:</div>
                  <div className="countdown-item">
                    <span className="countdown-value">{timeLeft.seconds}</span>
                    <span className="countdown-label">Seconds</span>
                  </div>
                </div>
                <div className="presale-dates">
                  <span>October 24, 2025 — November 30, 2025</span>
                </div>
              </div>

              <div
                className="presale-cta"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <Button
                  className="btn-action btn-lg"
                  onClick={scrollToParticipate}
                >
                  <FaFire className="me-2" />
                  Participate Now
                </Button>
                <div className="presale-warning mt-3">
                  <small>
                    Limited supply — the presale will close early once sold out!
                  </small>
                </div>
              </div>

              <div
                className="presale-stats"
                data-aos="fade-up"
                data-aos-delay="600"
              >
                <Row>
                  <Col md={4}>
                    <div className="stat-box">
                      <span className="stat-value">$10</span>
                      <span className="stat-label">Minimum Contribution</span>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="stat-box">
                      <span className="stat-value">$1,000</span>
                      <span className="stat-label">Maximum Per Wallet</span>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="stat-box">
                      <span className="stat-value">Limited</span>
                      <span className="stat-label">Available Supply</span>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PresaleHero;
